import React from 'react';
import styles from './TariffsBottomText.module.scss';

type Props = {
    isVip?: boolean;
};
const TariffsBottomText: React.FC<Props> = ({ isVip }) => {
    return (
        <div className={styles.container}>
            <p>Тарифы НДС не облагаются.</p>
            {!isVip && (
                <p>
                    Лицензия предоставляет льготные условия на действующие
                    тарифы и доступна в двух вариантах: разовая - 7 000₽ и 12
                    месяцев — 35 000₽
                </p>
            )}
            {!isVip && (
                <p>
                    * Лицензия позволяет участнику подать заявку на закупку при
                    наличии требуемой суммы на лицевом счёте. Сумма будет
                    заблокирована в момент подачи заявки. После публикации
                    итогового протокола происходит списание с победителя
                    заблокированных средств в размере тарифа.
                </p>
            )}
            {isVip && (
                <p>
                    * «Оплата победителем» позволяет участнику подать заявку на
                    закупку при наличии требуемой суммы на лицевом счёте. Сумма
                    будет заблокирована в момент подачи заявки. После публикации
                    итогового протокола происходит списание с победителя
                    заблокированных средств в размере тарифа. Участникам, не
                    победившим в закупке, сумма разблокируется.
                </p>
            )}
        </div>
    );
};

export default TariffsBottomText;
